
import { Component, Prop, Vue } from 'vue-property-decorator';
import { readCookie } from '@/tools/tools';
import Im from '@/components/im/im.vue';
import { State } from 'vuex-class';
import YSF from '@neysf/qiyu-web-sdk';

@Component({
  name: 'BackTop',
  components: {
    Im
  }
})
export default class extends Vue {
  isbackTop: boolean = false

  showIm: boolean = false // 是否显示IM

  picker: any = ''

  obj: any = {}

  @Prop({ default: false }) private isConsumables!: boolean

  @State('user') userInfo: any // 用户信息

  @Prop({ default: true }) private hasShopping!: boolean

  /** 是否展示购物车入口；订单详情等页传 false 仅保留客服+TOP */
  @Prop({ default: true }) private showCart!: boolean

  /** 显式控制客服入口；不传则与历史一致：由 hasShopping 决定（耗材 false 时隐藏） */
  @Prop({ default: undefined }) private showCustomer!: boolean | undefined

  @State('card') cardstate: any

  get isCustomerVisible() {
    if (this.isConsumables) {
      return false;
    }
    if (this.showCustomer !== undefined) {
      return this.showCustomer;
    }
    return this.hasShopping;
  }

  @State('home') homestate: any

  created() {
    window.addEventListener('scroll', this.handleScroll, true);
    if (this.$route.query.to === 'QtWebEngine') {
      this.openCustomer();
    }
  }

  setScrollDom(value: any) {
    this.obj = value;
  }

  closeIm() {
    this.showIm = false;
  }

  passpicker(picker: any) {
    this.picker = picker;
  }

  destroyed() {
    window.removeEventListener('scroll', this.handleScroll, true);
  }

  // 格式化日期
  formatDate(timestamp: any) {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(
      date.getDate()
    ).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(
      date.getMinutes()
    ).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`;
  }

  private openBrowser() {
    const ua = navigator.userAgent;
    const url = window.location.href;
    const anchor = readCookie('anchor');
    if (ua.includes('QtWebEngine')) {
      let qtUrl: string;
      if (url.includes('token')) {
        qtUrl = `${url}&to=QtWebEngine`;
      } else {
        const src = anchor && anchor.src ? anchor.src : 2;
        qtUrl = `${url}&src=${src}&model=${anchor.model}&version=${anchor.version}`
          + `&equipMeid=${anchor.equipMeid}&equipVersion=${anchor.equipVersion}&language=0`
          + `&equip=${anchor.equip}&appChannel=${anchor.appChannel}&macCode=${anchor.macCode}`
          + `&token=${anchor.accessToken}&to=QtWebEngine`;
      }
      (this as any).webTransport.openHyperlink(
        JSON.stringify({
          url: qtUrl,
          title: '商城',
          inside: 0, // 0:跳外部， 1:跳内部
          mall: 0, // 0:普通链接， 1:商城链接
          id: 0
        })
      );
    } else {
      this.openCustomer();
    }
  }

  private memberLevelLabel(level: number): string {
    if (level === 1) {
      return '黄金会员';
    }
    if (level === 2) {
      return '铂金会员';
    }
    if (level === 3) {
      return '黑卡会员';
    }
    return '';
  }

  private openCustomer() {
    const $that = this;
    if (readCookie('accessToken')) {
      (YSF as any)
        .init('f63f37230285130a3eb89565948cdcef', {
          sdkTemplateId: 8128534
        })
        .then((ysf: any) => {
          // 重置商品消息
          ysf.clearProduct();
          ysf('config', {
            uid: this.userInfo.userinfolist.id,
            name: this.userInfo.userinfolist.nickName,
            mobile: this.userInfo.userinfolist.phone,
            data: JSON.stringify([
              {
                index: 0,
                key: 'Source_channels',
                label: '来源渠道',
                value: '驰腾商城PC端'
              },
              {
                index: 1,
                key: 'grade_membership',
                label: '会员等级',
                value: this.memberLevelLabel(this.userInfo.userinfolist.level)
              },
              {
                index: 2,
                key: 'reg_date',
                label: '注册日期',
                value: this.formatDate(this.userInfo.userinfolist.createTime)
              },
              {
                index: 3,
                key: 'last_login',
                label: '上次登录时间',
                value: this.formatDate(this.userInfo.userinfolist.updateTime)
              },
              {
                index: 4,
                key: 'avatar',
                label: '头像',
                value: this.userInfo.userinfolist.headImgUrl
                  ? this.userInfo.userinfolist.headImgUrl
                  : ''
              },
              {
                index: 5,
                key: 'email',
                hidden: true,
                value: ''
              },
              {
                index: 6, key: 'integral', label: '会员积分', value: $that.userInfo.userinfolist.integral > 0 ? $that.userInfo.userinfolist.integral : '0'
              }
            ]),

            success() {
              // 成功回调,判断是web打开还是从PC端打开才触发发送商品
              const obj = JSON.parse(sessionStorage.getItem('detailsList') || '{}');

              if ($that.$route.path === '/details') {
                if ($that.$route.query.to === 'QtWebEngine') {
                  ysf('product', {
                    sendByUser: 1, // 是否由访客手动发送，1为是，其他参数为否
                    actionText: '发送链接', // 发送按钮文案
                    actionTextColor: '#000000', // 发送按钮文案颜色（16进制格式）
                    show: 1, // 1为打开，其他参数为隐藏（包括非零元素）
                    title: $that.obj.productName,
                    desc: $that.obj.productShortDesc,
                    note: `￥${$that.obj.lowestPrice.split(',')[0]}`,
                    picture: $that.obj.listImagePath?.cdnFilePathH5 || '',
                    url: `${process.env.VUE_APP_BASE_API}/details?id=${$that.$route.query.id}&productPriceId=${$that.$route.query.productPriceId}`
                  });
                } else {
                  ysf('product', {
                    sendByUser: 1, // 是否由访客手动发送，1为是，其他参数为否
                    actionText: '发送链接', // 发送按钮文案
                    actionTextColor: '#000000', // 发送按钮文案颜色（16进制格式）
                    show: 1, // 1为打开，其他参数为隐藏（包括非零元素）
                    title: obj.productName,
                    desc: obj.productShortDesc,
                    note: `￥${obj.lowestPrice.split(',')[0]}`,
                    picture: obj.listImagePath?.cdnFilePathH5 || '',
                    url: `${process.env.VUE_APP_BASE_API}/details?id=${obj.id}&productPriceId=${obj.productPriceId}`
                  });
                }
              }
            },
            error() {
              // 错误回调
              // handle error
            }
          });
          // 打开客服
          ysf('open');
        })
        .catch(() => {
          // 七鱼初始化失败时静默处理
        });
    } else {
      this.$router.push('/login?redirect=/grade');
    }
    // 原IM对接逻辑
    // let tempUrl = this.$route.fullPath;

    // if (!readCookie('accessToken')) {
    //   if (tempUrl.indexOf('?') !== -1) {
    //     tempUrl += '&openCustomer=1';
    //   } else {
    //     tempUrl += '?openCustomer=1';
    //   }
    //   writeCookie('openCustomer', '1');
    //   this.$router.push({ name: 'login', query: { redirect: tempUrl } });
    // } else {
    //   this.showIm = true;
    //   setTimeout(() => {
    //     this.picker.initData();
    //   }, 0);
    // }
  }

  private handleScroll() {
    const sT = document.documentElement.scrollTop || document.body.scrollTop; // 滚动距离
    // const headerHeight = (this as any).$refs.header.offsetHeight;
    this.isbackTop = sT >= 100;
  }

  goTop() {
    // 回到顶部
    window.scrollTo(0, 0);
  }
}
